import { Typography } from "@mui/material";

function Support() {
    return(
        <div>
            <Typography variant="h6"  gutterBottom>
            Support
            </Typography>
            <Typography variant="body1" gutterBottom>
                If you have any questions or need assistance, please reach out to mobidawg at: 
                <br/>
                <a href="mailto:support@mobidawg.com">
                    <span style={{ color: 'blue', textDecoration: 'underline' }}>support@mobidawg.com</span>
                </a>
            </Typography>
        </div>        
    )
}

export default Support;